/**
 * @generated SignedSource<<bad1ef693ba9c1994d366fa34c3f57d6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ActivityTab_activity$data = ReadonlyArray<{
  readonly __typename: "MessageActivity";
  readonly id: string;
  readonly createdAt: string;
  readonly body: string;
  readonly authorType: string;
  readonly direction: string | null;
  readonly author: {
    readonly fullName: string | null;
  } | null;
  readonly " $fragmentType": "ActivityTab_activity";
} | {
  readonly __typename: "InternalCommentActivity";
  readonly id: string;
  readonly createdAt: string;
  readonly body: string;
  readonly author: {
    readonly fullName: string | null;
  } | null;
  readonly mentionedUsers: ReadonlyArray<{
    readonly id: string;
    readonly fullName: string | null;
  }>;
  readonly " $fragmentType": "ActivityTab_activity";
} | {
  readonly __typename: "EventActivity";
  readonly id: string;
  readonly createdAt: string;
  readonly eventType: string;
  readonly actor: {
    readonly fullName: string | null;
  } | null;
  readonly oldValue: string | null;
  readonly newValue: string | null;
  readonly " $fragmentType": "ActivityTab_activity";
} | {
  readonly __typename: "AttachmentActivity";
  readonly id: string;
  readonly createdAt: string;
  readonly filename: string;
  readonly " $fragmentType": "ActivityTab_activity";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "ActivityTab_activity";
}>;
export type ActivityTab_activity$key = ReadonlyArray<{
  readonly " $data"?: ActivityTab_activity$data;
  readonly " $fragmentSpreads": FragmentRefs<"ActivityTab_activity">;
}>;

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v4 = [
  (v3/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "ActivityTab_activity",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "authorType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "direction",
          "storageKey": null
        },
        (v5/*: any*/)
      ],
      "type": "MessageActivity",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Person",
          "kind": "LinkedField",
          "name": "mentionedUsers",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v3/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "InternalCommentActivity",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "eventType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Person",
          "kind": "LinkedField",
          "name": "actor",
          "plural": false,
          "selections": (v4/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "oldValue",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "newValue",
          "storageKey": null
        }
      ],
      "type": "EventActivity",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "filename",
          "storageKey": null
        }
      ],
      "type": "AttachmentActivity",
      "abstractKey": null
    }
  ],
  "type": "ActivityEvent",
  "abstractKey": "__isActivityEvent"
};
})();

(node as any).hash = "e5cf9b8af86841602ffac7ca73df6741";

export default node;
